const validate = values => {
    const errors = {}
    const requiredFields = [
        'password',
        'confirmPassword'
    ]

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'fieldRequired'
        }
    });

    if (values.password !== values.confirmPassword) {
        errors.confirmNewPassword = 'Паролите не съвпадат'
    }

    return errors
}

export default validate